import moment from 'moment';
import React from 'react';
import { strings } from '../../../resources/strings';
import { OrderLog } from '../../../models/OrderLog';
import { Table } from '../../../common-components/Table/Table';
import { Container } from './styles';

interface ITabHistoricProps {
  historic?: OrderLog[];
}

export const TabHistoric: React.FC<ITabHistoricProps> = ({
  historic
}) => {

  const items = React.useMemo(() => {
    return (
      <Table>
        <thead>
          <tr>
            <th style={{ width: '175px', minWidth: '175px' }}>{strings.Date}</th>
            <th style={{ width: '100%' }}>{strings.Details}</th>
            <th style={{ width: '150px', minWidth: '200px' }}>{strings.User}</th>
          </tr>
        </thead>
        <tbody>
          {historic?.map((item, itemIndex) => {
            return (
              <tr key={`historic-item-${itemIndex}`}>
                <td>{moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
                <td>{item.details}</td>
                <td>{item.doneBy?.name}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }, [historic]);

  return (
    <Container>
      {items}
    </Container>
  );
};